import { useAssistantContext } from 'features/pi/view/hooks/useAssistantContext';

export function useResourceFactory() {
    const context = useAssistantContext();

    return context.resourceFactory!;
}
